/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_DescriptionInputs */

const en_guide_json_rest_api_description = /** @type {(inputs: Guide_Json_Rest_Api_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how JSON works with REST APIs. Understand request/response formats, headers, status codes, and best practices for API development.`)
};

const ko_guide_json_rest_api_description = /** @type {(inputs: Guide_Json_Rest_Api_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST API에서 JSON이 어떻게 작동하는지 알아보세요. 요청/응답 포맷, 헤더, 상태 코드, API 개발 모범 사례를 이해합니다.`)
};

const ja_guide_json_rest_api_description = /** @type {(inputs: Guide_Json_Rest_Api_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONとREST APIの連携方法を学びましょう。リクエスト/レスポンスの形式、ヘッダー、ステータスコード、API開発のベストプラクティスを理解できます。`)
};

/**
* | output |
* | --- |
* | "Learn how JSON works with REST APIs. Understand request/response formats, headers, status codes, and best practices for API development." |
*
* @param {Guide_Json_Rest_Api_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_description = /** @type {((inputs?: Guide_Json_Rest_Api_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_description(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_description(inputs)
	return ja_guide_json_rest_api_description(inputs)
});